export const styleguideVariants = {
  updatedAt: '2024-12-03T13:37:08.389Z',
  id: 21418,
  ownerId: 2673,
  variants: {
    Global: {
      base: {
        name: 'Base',
        selectors: {
          global: {
            rules: {
              '--color-lines': '#D4D7D8',
              '--color-danger': '#D64045',
              '--color-neutral': '#F5F5F5',
              '--color-primary': '#202020',
              '--color-success': '#6BAA75',
              '--color-warning': '#F58F29',
              '--color-tertiary': '#696E78',
              '--text-font-size': '16px',
              '--color-secondary': '#60AFFF',
              '--color-background': '#FAFAFA',
              '--text-font-family': 'Roboto',
              '--text-font-weight': '100',
              '--text-line-height': 'initial',
            },
          },
        },
      },
    },
    Checklist: {
      base: {
        name: 'CheckList',
        selectors: {
          checklist_item: {
            rules: {
              '--color': 'var(--color-primary)',
              '--margin': '0px 0px 16px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--border-color': 'var(--checklist-item-border-color)',
              '--border-style': 'solid',
              '--border-width': 'var(--checklist-item-border-width)',
              '--border-radius': '4px',
              '--background-color': '#ffffff',
              '--checklist-item-border-color': 'var(--color-lines)',
              '--checklist-item-border-width': '1px',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          checklist_item_focus: { rules: { '--border-color': '#c5c7c8' } },
          checklist_item_hover: { rules: { '--border-color': '#c5c7c8' } },
          checklist_group_title: {
            rules: {
              '--color': 'var(--color-primary)',
              '--margin': '0px 0px 8px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '24px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          checklist_progress_bar: {
            rules: {
              '--height': '100%',
              '--transition': 'all .35s ease-out 0s',
              '--background-color': 'var(--color-secondary)',
            },
          },
          checklist_checkbox_base: {
            rules: {
              '--width': '20px',
              '--cursor': 'pointer',
              '--height': '20px',
              '--margin': '16px 16px 16px 16px',
              '--display': 'flex',
              '--outline': 'none',
              '--padding': '0px 0px 0px 0px',
              '--transition': 'all .1s ease-out 0s',
              '--align-items': 'center',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--justify-content': 'center',
            },
          },
          checklist_checkbox_checked: {
            rules: {
              '--border-color': 'transparent',
              '--background-color': 'var(--color-secondary)',
              '--checkbox-checked-arrow-color': '#ffffff',
            },
          },
          checklist_checkbox_unchecked: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#fff' },
          },
          checklist_checkbox_checked_focus: {
            rules: { '--border-color': 'transparent', '--background-color': '#559ee8' },
          },
          checklist_checkbox_checked_hover: {
            rules: { '--border-color': 'transparent', '--background-color': '#559ee8' },
          },
          checklist_progress_bar_container: {
            rules: {
              '--width': '100%',
              '--height': '4px',
              '--margin': '0px 0px 16px 0px',
              '--border-radius': '10px',
              '--background-color': 'var(--color-neutral)',
            },
          },
          checklist_checkbox_disabled_hover: { rules: { '--cursor': 'default' } },
          checklist_checkbox_unchecked_focus: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#edf0f5' },
          },
          checklist_checkbox_unchecked_hover: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#edf0f5' },
          },
        },
      },
      accordion: {
        name: 'Accordion',
        selectors: {
          checklist_item: {
            rules: {
              '--color': 'var(--color-primary)',
              '--margin': '0px 0px 8px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--border-color': 'var(--checklist-item-border-color)',
              '--border-style': 'solid',
              '--border-width': 'var(--checklist-item-border-width)',
              '--border-radius': '4px',
              '--background-color': '#ffffff',
              '--checklist-item-border-color': 'var(--color-lines)',
              '--checklist-item-border-width': '1px',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          checklist_item_focus: { rules: { '--border-color': '#c5c7c8' } },
          checklist_item_hover: { rules: { '--border-color': '#c5c7c8' } },
          checklist_group_title: {
            rules: {
              '--color': 'var(--color-primary)',
              '--margin': '0px 0px 8px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '24px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          checklist_progress_bar: {
            rules: {
              '--height': '100%',
              '--transition': 'all .35s ease-out 0s',
              '--background-color': 'var(--color-secondary)',
            },
          },
          checklist_checkbox_base: {
            rules: {
              '--width': '0px',
              '--cursor': 'pointer',
              '--height': '0px',
              '--margin': '16px 8px 16px 0px',
              '--display': 'flex',
              '--outline': 'none',
              '--padding': '0px 0px 0px 0px',
              '--transition': 'all .1s ease-out 0s',
              '--align-items': 'center',
              '--border-style': 'solid',
              '--border-width': '0px',
              '--border-radius': '4px',
              '--justify-content': 'center',
            },
          },
          checklist_checkbox_checked: {
            rules: {
              '--border-color': 'transparent',
              '--background-color': 'var(--color-secondary)',
              '--checkbox-checked-arrow-color': '#ffffff',
            },
          },
          checklist_checkbox_unchecked: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#fff' },
          },
          checklist_checkbox_checked_focus: {
            rules: { '--border-color': 'transparent', '--background-color': '#559ee8' },
          },
          checklist_checkbox_checked_hover: {
            rules: { '--border-color': 'transparent', '--background-color': '#559ee8' },
          },
          checklist_progress_bar_container: {
            rules: {
              '--width': '100%',
              '--height': '4px',
              '--margin': '0px 0px 16px 0px',
              '--border-radius': '10px',
              '--background-color': 'var(--color-neutral)',
            },
          },
          checklist_checkbox_disabled_hover: { rules: { '--cursor': 'default' } },
          checklist_checkbox_unchecked_focus: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#edf0f5' },
          },
          checklist_checkbox_unchecked_hover: {
            rules: { '--border-color': 'var(--color-lines)', '--background-color': '#edf0f5' },
          },
        },
      },
    },
    Card: {
      base: {
        name: 'Action card!',
        selectors: {
          card_base: {
            rules: {
              '--color': 'var(--color-neutral)',
              '--cursor': 'pointer',
              '--margin': '0px 0px 0px 0px',
              '--padding': '52px 52px 52px 52px',
              '--font-size': '16px',
              '--box-shadow': '0px 0px 0px 0px #fff',
              '--card-stroke': '#565e61',
              '--border-color': '#e9ebec',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'var(--color-background)',
              '--card-stroke-width': '2px',
            },
          },
          card_hover: {
            rules: {
              '--box-shadow': '0px 0px 0px 0px #fff',
              '--border-color': 'var(--color-lines)',
              '--background-color': 'var(--color-neutral)',
            },
          },
        },
      },
      clean: {
        name: 'No action card',
        selectors: {
          card_base: {
            rules: {
              '--color': 'var(--color-neutral)',
              '--cursor': 'default',
              '--margin': '0px 0px 0px 0px',
              '--padding': '52px 52px 52px 52px',
              '--font-size': '16px',
              '--box-shadow': '0',
              '--card-stroke': '#565e61',
              '--border-color': '#E9EBEC',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'var(--color-background)',
              '--card-stroke-width': '2',
            },
          },
          card_hover: {
            rules: {
              '--border-color': '#E9EBEC',
              '--background-color': 'var(--color-background)',
            },
          },
        },
      },
      border: {
        name: 'Border card',
        selectors: {
          card_base: {
            rules: {
              '--color': 'var(--color-neutral)',
              '--cursor': 'default',
              '--margin': '0px 0px 0px 0px',
              '--padding': '52px 52px 52px 52px',
              '--font-size': '16px',
              '--box-shadow': '0px 0px 0px 0px #c2c7d736',
              '--card-stroke': '#565e61',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': '#fff',
              '--card-stroke-width': '2',
            },
          },
          card_hover: {
            rules: {
              '--box-shadow': '1px 1px 6px 1px #eff1f7',
              '--border-color': 'var(--color-lines)',
              '--background-color': '#fff',
            },
          },
        },
      },
      transparent: {
        name: 'Transparent Card',
        selectors: {
          card_base: {
            rules: {
              '--color': 'var(--color-neutral)',
              '--cursor': 'pointer',
              '--margin': '0px 0px 0px 0px',
              '--padding': '52px 52px 52px 52px',
              '--font-size': '16px',
              '--box-shadow': '0px 0px 0px 0px #000',
              '--card-stroke': 'var(--color-neutral)',
              '--border-color': 'transparent',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
              '--card-stroke-width': '2',
            },
          },
          card_hover: {
            rules: {
              '--box-shadow': '0px 0px 0px 0px #000',
              '--border-color': 'transparent',
              '--background-color': 'transparent',
            },
          },
        },
      },
    },
    Form: {
      base: {
        name: 'Form',
        selectors: {
          form_base: { rules: { '--color': '#575E75' } },
          form_label: {
            rules: {
              '--color': '#565e61',
              '--margin': '0px 0px 8px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          form_mscard: {
            rules: {
              '--margin': '0px 0px 0px 0px',
              '--outline': 'none',
              '--padding': '0px 0px 0px 0px',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '8px',
              '--background-color': 'transparent',
            },
          },
          form_sscard: {
            rules: {
              '--margin': '0px 0px 0px 0px',
              '--outline': 'none',
              '--padding': '0px 0px 0px 0px',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '8px',
              '--background-color': 'transparent',
            },
          },
          form_checkbox: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--margin': '0px 0px 8px 0px',
              '--padding': '0px 0px 0px 0px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          form_inputfield: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--height': '40px',
              '--margin': '0px 0px 7px 0px',
              '--outline': 'none',
              '--padding': '0px 0px 0px 8px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': 'normal',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '8px',
              '--background-color': '#fff',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          form_mscard_svg: { rules: { '--visibility': 'hidden' } },
          form_sscard_svg: { rules: { '--visibility': 'hidden' } },
          form_checkboxdiv: {
            rules: {
              '--width': '30px',
              '--height': '30px',
              '--margin': '0px 8px 0px 0',
              '--resize': 'none',
              '--display': 'flex',
              '--align-items': 'center',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '8px',
              '--checkbox-size': '11px',
              '--justify-content': 'center',
              '--background-color': '#FFF',
              '--active-background-color': '#FFF',
            },
          },
          form_label_error: { rules: { '--color': '#ff5a5f' } },
          form_checkbox_svg: { rules: { '--visibility': 'hidden' } },
          form_mscard_error: { rules: { '--border-color': 'var(--color-danger)' } },
          form_mscard_focus: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_mscard_hover: {
            rules: {
              '--cursor': 'pointer',
              '--border-color': '#565e61',
              '--background-color': '#fff',
            },
          },
          form_sscard_error: {
            rules: { '--border-color': 'var(--color-danger)', '--background-color': '#fff' },
          },
          form_sscard_focus: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_sscard_hover: {
            rules: {
              '--cursor': 'pointer',
              '--border-color': '#565e61',
              '--background-color': '#fff',
            },
          },
          form_error_message: {
            rules: {
              '--color': '#ff5a5f',
              '--font-size': '10px',
              '--text-align': 'right',
              '--font-family': 'Roboto',
              '--font-weight': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          form_mscard_selected: {
            rules: { '--border-color': 'var(--color-primary)', '--background-color': '#fff' },
          },
          form_sscard_selected: {
            rules: { '--border-color': 'var(--color-primary)', '--background-color': '#fff' },
          },
          form_inputfield_error: { rules: { '--border-color': 'var(--color-danger)' } },
          form_inputfield_focus: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_inputfield_hover: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_checkboxdiv_error: { rules: { '--border-color': 'var(--color-danger)' } },
          form_checkboxdiv_focus: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_checkboxdiv_hover: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_mscard_checkboxdiv: {
            rules: {
              '--width': '18px',
              '--height': '18px',
              '--margin': '0px 0px 0px 0',
              '--resize': 'none',
              '--display': 'flex',
              '--align-items': 'center',
              '--border-color': 'var(--color-lines)',
              '--border-style': 'solid',
              '--border-width': '1px',
              '--border-radius': '8px',
              '--checkbox-size': '8px',
              '--justify-content': 'center',
              '--background-color': '#fff',
              '--active-background-color': '#fff',
            },
          },
          form_inputfield_textarea: { rules: { '--height': '100px', '--padding': '8px' } },
          form_mscard_selected_svg: { rules: { '--visibility': 'visible' } },
          form_checkboxdiv_selected: {
            rules: {
              '--background-color': 'var(--color-primary)',
              '--checkbox-color-fill': '#ffffff',
            },
          },
          form_inputfield_placeholder: { rules: { '--color': '#565e61' } },
          form_checkboxdiv_selected_svg: { rules: { '--visibility': 'visible' } },
          form_mscard_checkboxdiv_error: { rules: { '--border-color': 'var(--color-danger)' } },
          form_mscard_checkboxdiv_focus: {
            rules: { '--border-color': '#565e61', '--background-color': '#fff' },
          },
          form_mscard_checkboxdiv_hover: {
            rules: {
              '--cursor': 'pointer',
              '--border-color': '#565e61',
              '--background-color': '#fff',
            },
          },
          form_mscard_checkboxdiv_selected: {
            rules: {
              '--background-color': 'var(--color-primary)',
              '--checkbox-color-fill': '#fff',
            },
          },
        },
      },
    },
    TourStep: {
      base: {
        name: 'TourStep',
        selectors: {
          tour_dismiss: { rules: { '--padding': '8px 8px 8px 8px' } },
          tour_dismiss_svg: { rules: { '--tour-stroke': '#1D1D1D', '--tour-stroke-width': '2' } },
          tour_step_tooltip_body: { rules: { '--padding': '8px 8px 8px 8px' } },
          tour_step_tooltip_arrow: { rules: { '--width': '20px' } },
          tour_step_tooltip_wrapper: {
            rules: {
              '--drop-shadow': '2px 2px 6px #68718d3d',
              '--border-color': 'transparent',
              '--border-style': 'solid',
              '--border-width': '0px',
              '--border-radius': '4px',
              '--background-color': '#FFFFFF',
            },
          },
        },
      },
    },
    Button: {
      base: {
        name: 'Primary',
        selectors: {
          button_base: {
            rules: {
              '--color': '#fff',
              '--cursor': 'pointer',
              '--height': 'initial',
              '--margin': '0px 0px 0px 0px',
              '--padding': '8px 16px 8px 16px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-primary)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'var(--color-primary)',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': '#ffffff',
              '--font-weight': '500',
              '--border-color': '#353538',
              '--background-color': '#353538',
            },
          },
          button_hover: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#3C3C3C',
              '--background-color': '#3c3c3c',
            },
          },
          button_active: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#353538',
              '--background-color': '#353538',
            },
          },
        },
      },
      danger: {
        name: 'Danger',
        selectors: {
          button_base: {
            rules: {
              '--color': '#fff',
              '--cursor': 'pointer',
              '--margin': '0px 0px 0px 0px',
              '--padding': '8px 16px 8px 16px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'transparent',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': '#ff5a5f',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': '#ffffff',
              '--font-weight': '500',
              '--border-color': '#c0373c',
              '--background-color': '#c0373c',
            },
          },
          button_hover: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#c0373c',
              '--background-color': '#c0373c',
            },
          },
          button_active: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#c0373c',
              '--background-color': '#c0373c',
            },
          },
        },
      },
      warning: {
        name: 'Warning',
        selectors: {
          button_base: {
            rules: {
              '--color': '#fff',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-warning)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'var(--color-warning)',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': '#ffffff',
              '--font-weight': '500',
              '--border-color': '#de8123',
              '--background-color': 'var(--color-warning)',
            },
          },
          button_hover: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#de8123',
              '--background-color': '#de8123',
            },
          },
          button_active: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': '#de8123',
              '--background-color': 'var(--color-warning)',
            },
          },
        },
      },
      tertiary: {
        name: 'Tertiary',
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-lines)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-weight': '500',
              '--border-color': 'var(--color-tertiary)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-weight': '500',
              '--border-color': 'var(--color-tertiary)',
              '--background-color': 'transparent',
            },
          },
          button_active: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-weight': '500',
              '--border-color': 'var(--color-tertiary)',
              '--background-color': 'transparent',
            },
          },
        },
      },
      secondary: {
        name: 'Secondary',
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-neutral)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'var(--color-neutral)',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': '#ffffff',
              '--font-weight': '500',
              '--border-color': 'var(--color-primary)',
              '--background-color': 'var(--color-primary)',
            },
          },
          button_hover: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': 'var(--color-primary)',
              '--background-color': 'var(--color-primary)',
            },
          },
          button_active: {
            rules: {
              '--color': '#fff',
              '--font-weight': '500',
              '--border-color': 'var(--color-primary)',
              '--background-color': 'var(--color-primary)',
            },
          },
        },
      },
      base_light: {
        name: 'Primary Light',
        isHidden: true,
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--cursor': 'pointer',
              '--height': 'initial',
              '--padding': '8px 16px 8px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-primary)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-primary)',
              '--border-color': 'var(--color-primary)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-primary)',
              '--border-color': 'var(--color-primary)',
              '--background-color': 'transparent',
            },
          },
        },
      },
      danger_light: {
        name: 'Danger',
        isHidden: true,
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-danger)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-danger)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-danger)',
              '--border-color': 'var(--color-danger)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-danger)',
              '--border-color': 'var(--color-danger)',
              '--background-color': 'transparent',
            },
          },
        },
      },
      warning_light: {
        name: 'Warning Light',
        isHidden: true,
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-warning)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-warning)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-warning)',
              '--border-color': 'var(--color-warning)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-warning)',
              '--border-color': 'var(--color-warning)',
              '--background-color': 'transparent',
            },
          },
        },
      },
      tertiary_light: {
        name: 'Tertiary',
        isHidden: true,
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-tertiary)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--border-color': 'var(--color-tertiary)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--border-color': 'var(--color-tertiary)',
              '--background-color': 'transparent',
            },
          },
        },
      },
      secondary_light: {
        name: 'Secondary Light',
        isHidden: true,
        selectors: {
          button_base: {
            rules: {
              '--color': 'var(--color-secondary)',
              '--cursor': 'pointer',
              '--padding': '8px 16px 8px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-secondary)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          button_focus: {
            rules: {
              '--color': 'var(--color-secondary)',
              '--border-color': 'var(--color-secondary)',
              '--background-color': 'transparent',
            },
          },
          button_hover: {
            rules: {
              '--color': 'var(--color-secondary)',
              '--border-color': 'var(--color-secondary)',
              '--background-color': 'transparent',
            },
          },
        },
      },
    },
    Modal: {
      base: {
        name: 'Modal',
        selectors: {
          modalV2_base: {
            rules: {
              '--width': '640px',
              '--height': 'auto',
              '--margin': '0px 0px 0px 0px',
              '--padding': '32px 32px 32px 32px',
              '--max-width': '100%',
              '--min-width': 'auto',
              '--max-height': 'auto',
              '--min-height': 'auto',
              '--border-width': '0px',
              '--border-radius': '15px',
            },
          },
          modalV2_wrapper: { rules: { '--z-index': '5000' } },
          modalV2_backdrop: { rules: { '--background-color': '#00000080' } },
        },
      },
    },
    Badge: {
      base: {
        name: 'Primary',
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--height': 'initial',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-tertiary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'var(--color-neutral)',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      danger: {
        name: 'Danger',
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-danger)',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-danger)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': '#fbf0f1',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      warning: {
        name: 'Warning',
        selectors: {
          badge_base: {
            rules: {
              '--color': '#ce7318',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-warning)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': '#fffaf3',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      tertiary: {
        name: 'Tertiary',
        selectors: {
          badge_base: {
            rules: {
              '--color': '#ffffff',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
              '--line-height': 'initial',
              '--border-color': 'var(--color-primary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'var(--color-primary)',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      secondary: {
        name: 'Secondary',
        selectors: {
          badge_base: {
            rules: {
              '--color': '#367ec5',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': '12px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': 'initial',
              '--border-color': 'var(--color-secondary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': '#ebf4ff',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      base_light: {
        name: 'Primary Light',
        isHidden: true,
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--height': 'initial',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-primary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      danger_light: {
        name: 'Danger Light',
        isHidden: true,
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-danger)',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-danger)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      warning_light: {
        name: 'Warning Light',
        isHidden: true,
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-warning)',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-warning)',
              '--border-width': '1px',
              '--border-radius': '4px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      tertiary_light: {
        name: 'Tertiary Light',
        isHidden: true,
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-tertiary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      secondary_light: {
        name: 'Secondary Light',
        isHidden: true,
        selectors: {
          badge_base: {
            rules: {
              '--color': 'var(--color-secondary)',
              '--margin': '0px 0px 0px 0px',
              '--padding': '4px 16px 4px 16px',
              '--font-size': 'var(--text-font-size)',
              '--font-family': 'var(--text-font-family)',
              '--font-weight': 'bold',
              '--line-height': 'initial',
              '--border-color': 'var(--color-secondary)',
              '--border-width': '1px',
              '--border-radius': '16px',
              '--background-color': 'transparent',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
    },
    Link: {
      base: {
        name: 'Link',
        selectors: {
          link_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--cursor': 'pointer',
              '--font-family': 'Roboto',
              '--font-weight': 'normal',
              '--line-height': 'unset',
              '--letter-spacing': 'unset',
              '--text-decoration': 'none',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
          link_focus: { rules: { '--color': '#565e61', '--text-decoration': 'normal' } },
          link_hover: { rules: { '--color': '#565e61', '--text-decoration': 'normal' } },
          link_visited: { rules: { color: '#565e61', '--font-style': 'normal' } },
        },
      },
    },
    Hotspot: {
      base: {
        name: 'Hotspot',
        selectors: {
          hotspot_dismiss: { rules: { '--padding': '8px 8px 8px 8px' } },
          hotspot_beacon_svg: { rules: { '--width': '32px', '--beacon-color': '#6310E5' } },
          hotspot_dismiss_svg: {
            rules: { '--hotspot-stroke': '#1D1D1D', '--hotspot-stroke-width': '2' },
          },
          hotspot_tooltip_body: { rules: { '--padding': '8px 8px 8px 8px' } },
          hotspot_tooltip_arrow: { rules: { '--width': '20px' } },
          hotspot_tooltip_wrapper: {
            rules: {
              '--drop-shadow': '2px 2px 6px #68718d3d',
              '--border-color': 'transparent',
              '--border-style': 'solid',
              '--border-width': '0px',
              '--border-radius': '4px',
              '--background-color': '#FFFFFF',
            },
          },
        },
      },
    },
    Typography: {
      H1: {
        name: 'Heading 1!',
        tagName: 'h1',
        selectors: {
          typography_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-size': '40px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
              '--line-height': '48px',
              '--letter-spacing': '0px',
              '--text-decoration': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      H2: {
        name: 'Heading 2',
        tagName: 'h2',
        selectors: {
          typography_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-size': '32px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
              '--line-height': '40px',
              '--letter-spacing': '0px',
              '--text-decoration': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      H3: {
        name: 'Heading 3',
        tagName: 'h3',
        selectors: {
          typography_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-size': '24px',
              '--font-family': 'Roboto',
              '--font-weight': '700',
              '--line-height': '32px',
              '--letter-spacing': '0px',
              '--text-decoration': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      H4: {
        name: 'Heading 4',
        tagName: 'h4',
        selectors: {
          typography_base: {
            rules: {
              '--color': 'var(--color-primary)',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': '500',
              '--line-height': '22px',
              '--letter-spacing': '0px',
              '--text-decoration': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
      base: {
        name: 'Paragraph',
        tagName: 'p',
        selectors: {
          typography_base: {
            rules: {
              '--color': 'var(--color-tertiary)',
              '--font-size': '16px',
              '--font-family': 'Roboto',
              '--font-weight': 'normal',
              '--line-height': '22px',
              '--letter-spacing': '0px',
              '--text-decoration': 'normal',
            },
            imports: {
              '--font-family':
                'https://fonts.googleapis.com/css2?display=block&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
            },
          },
        },
      },
    },
  },
};
